import {
  ADMIN_DASH_REQUEST, ADMIN_DASH_FAIL, ADMIN_DASH_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  //  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const AdminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_DASH_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case ADMIN_DASH_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case ADMIN_DASH_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default AdminDashboardReducer;
